<template>
  <b-row>
    <b-col
      v-show="loadingIssuesSelectOptions || issuesSelectOptionsLength"
      md="6"
      lg="6"
    >
      <card>
        <!-- Card header -->
        <h3 slot="header" class="mb-0">Cadastrar Requerimento</h3>
        <!-- Card body -->

        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)"
          >
            <div class="form-row">
              <b-col md="12">
                <base-input
                  success-message="Ok!"
                  rules="required"
                  name="Tipo"
                  label="Tipo de Requerimento"
                >
                  <el-select
                    @change="changeSelectItem"
                    v-model="form.selectedTypeIssues"
                    name="Selected"
                    filterable
                    placeholder="Tipo de Requerimento"
                  >
                    <el-option
                      v-for="option in issuesSelectOptions"
                      :key="option.id"
                      :label="option.label"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>

              <b-col md="12">
                <base-input
                  success-message="Ok!"
                  rules="required"
                  label="Comentário"
                >
                  <textarea
                    class="form-control"
                    v-model="form.issuesComentary"
                    id="issuesComentary"
                    name="Comentário"
                    rows="3"
                  ></textarea>
                </base-input>
              </b-col>
            </div>
            <b-alert :show="showAlert" dismissible variant="danger">
              <span class="alert-text"
                >Algo deu errado. Tente novamente mais tarde</span
              >
            </b-alert>

            <base-button
              :disabled="disableSubmitButton"
              type="primary"
              native-type="submit"
              >{{ submitButtonText }}</base-button
            >
          </form>
        </validation-observer>
      </card>
    </b-col>
    <b-col
      v-show="loadingIssuesSelectOptions || issuesSelectOptionsLength"
      md="6"
      lg="6"
    >
      <card>
        <!--Card Header-->
        <h3 slot="header" class="mb-0">Informações do Requerimento</h3>
        <!--Card Body-->
        <b-card-body class="pl-0 pt-0">
          <p v-if="showInitialTextInfoIssues" class="mb-0">
            Escolha um tipo de requerimento...
          </p>
          <p v-html="infoIssues" v-else class="mb-0"></p>
        </b-card-body>
      </card>
    </b-col>
    <b-col v-show="!issuesSelectOptionsLength" lg="12"
      ><card
        ><!-- Card header -->
        <h3 slot="header" class="mb-0">
          Impossível criar novos requerimentos
        </h3>
        <b-card-body class="pt-0">
          <b-card-title title-tag="h3" class="pt-0">Nota</b-card-title>
          <b-card-text class="mb-4"
            >** Para criar um requerimento é preciso cadastrar os<span
              class="h3"
            >
              tipos de requerimento</span
            >. Nenhum tipo de requerimento foi encontrado para esta
            instituição.</b-card-text
          >
          <router-link
            v-if="addPlaceIssuetypes"
            :to="{ path: '/configurations/issuesTypes/add' }"
          >
            <a class="btn btn-link px-0">Cadastrar tipo de requerimento</a>
          </router-link>
        </b-card-body>
        <!-- Card body this.$router.push("/issues/add"); --></card
      ></b-col
    >
  </b-row>
</template>
<script>
import { Select, Option } from "element-ui"
import swal from "sweetalert2";
import nodeApi from "@/services/nodejs/index"
import { mapGetters } from "vuex"

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  data() {
    return {
      validated: false,
      submitButtonText: "Enviar",
      showAlert: false,
      addPlaceIssuetypes: null,
      loadingIssuesSelectOptions: true,
      disableSubmitButton: false,
      form: {
        selectedTypeIssues: null,
        issuesComentary: null,
        agree: false
      },
      issuesSelectOptions: [],
      showInitialTextInfoIssues: true,
      infoIssues: null
    };
  },
  computed: {
    issuesSelectOptionsLength() {
      return this.issuesSelectOptions.length;
    },
    ...mapGetters(["roles"])
  },
  created() {
    this.getTiposRequerimentosAtivos();
  },
  methods: {
    getConfigurationsRoles() {
      this.addPlaceIssuetypes = this.roles.configurations.find(
        role =>
          role.controller === "configurations" &&
          role.action === "issuesTypes/add"
      );
    },
    async firstFormSubmit() {
      this.submitButtonText = "Enviando...";
      this.disableSubmitButton = true;
      nodeApi
        .cadastrarRequerimento(
          this.form.issuesComentary,
          this.form.selectedTypeIssues
        )
        .then(rsp => {
          console.log("resposta cadastrarRequerimento ", rsp.data);
          this.submitButtonText = "Enviando...";
          this.disableSubmitButton = false;
          this.$router.push("/issues");
          this.showSwal(
            "Sucesso!!",
            "Requerimento cadastrado com sucesso !!",
            "primary",
            "success"
          );
        })
        .catch(() => {
          this.submitButtonText = "Enviar";
          this.showAlert = true;
          this.disableSubmitButton = false;
          this.showSwal(
            "Erro!!",
            "Algo deu errado. Tente novamente mais tarde !!",
            "warning",
            "warning"
          );
        });
    },
    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        text: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`,
        icon: icon
      });
    },
    getTiposRequerimentosAtivos() {
      this.loadingIssuesSelectOptions = true;
      nodeApi.getTiposRequerimentosAtivos().then(rsp => {
        this.issuesSelectOptions = rsp.data || [];
        this.loadingIssuesSelectOptions = false;
      });
    },
    changeSelectItem() {
      var issuesType = this.issuesSelectOptions.find(issuesElem => {
        return issuesElem.id == this.form.selectedTypeIssues;
      });
      this.infoIssues = issuesType.description;
      this.showInitialTextInfoIssues = false;
    }
  },
  mounted() {
    this.roles.configurations ? this.getConfigurationsRoles() : "";
  }
};
</script>
<style></style>
